import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AutocompleteDropdown } from 'src/shared/components/form/autocompleteDropdown';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { InvoiceGroup } from 'src/shared/models/invoiceGroup/invoiceGroup';
import { getAllInvoiceGroups } from 'src/shared/services/invoiceGroupService';

type InvoiceGroupsProps = {
  ownerId: number | undefined;
  autoSelect?: boolean;
  placeholder?: string;
  emptyLabel?: string;
  required?: boolean;
  callback: (invoiceGroupId: number) => void;
  name?: string;
  disable?: boolean;
};
export const InvoiceGroups = (props: InvoiceGroupsProps) => {
  const {
    name = undefined,
    ownerId,
    autoSelect = false,
    placeholder = undefined,
    emptyLabel = undefined,
    required = false,
    callback,
    disable = false,
  } = props;
  const isMounted = useIsMounted();
  const { t } = useTranslation(['invoice']);
  const [invoiceGroups, setInvoiceGroups] = useState<InvoiceGroup[]>();
  const [invoiceGroupId, setInvoiceGroupId] = useState<number>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getAllInvoiceGroups(0, 500, 'name', 'asc', '');
        if (isMounted()) {
          setInvoiceGroups(result.data.results);
        }
      } catch (e) {
        if (isMounted()) {
          ConsoleHelper.log(e);
        }
      }
    };

    fetchData();
  }, [isMounted]);

  const updateInvoiceGroup = useCallback(
    (val: number) => {
      callback(val);
      setInvoiceGroupId(val);
    },
    [callback],
  );

  useEffect(() => {
    if (invoiceGroups?.length && ownerId) setInvoiceGroupId(ownerId);
    // Autoselect om det bara finns en fakturagrupp
    if (invoiceGroups?.length && !ownerId && invoiceGroups?.length === 1 && autoSelect) updateInvoiceGroup(invoiceGroups[0].owner_id);
  }, [autoSelect, invoiceGroups, invoiceGroups?.length, ownerId, updateInvoiceGroup]);

  return (
    <>
      {invoiceGroups && invoiceGroups.length > 0 && (
        <AutocompleteDropdown<InvoiceGroup>
          options={invoiceGroups}
          nameProp='name'
          keyProp='name'
          name={name ?? 'invoiceGroup'}
          required={required}
          placeholder={placeholder}
          label={t('invoice:invoiceGroups')}
          emptyLabel={emptyLabel}
          value={invoiceGroupId ? invoiceGroups.filter((x) => x.owner_id === invoiceGroupId)[0] : undefined}
          callback={(val) => updateInvoiceGroup(val && val.owner_id ? val.owner_id : 0)}
          disable={disable}
        />
      )}
    </>
  );
};
